module.exports = __webpack_public_path__ + "img/wh_ico.04ce4a75.png";